// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "wrapper-1jjhc";
var _5 = "footer-1l_Ea";
var _6 = "footer__button-gUMgA";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "wrapper", _5 as "footer", _6 as "footer__button" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "wrapper": _4, "footer": _5, "footer__button": _6 }
